import { IField } from "../../../types/Form/IForm";
import dateFieldValidator from "./DateFieldValidator";
import dropdownFieldValidator from "./DropdownFieldValidator";
import endUserFieldValidator from "./EndUserFieldValidator";
import numberFieldValidator from "./NumberFieldValidator";
import textFieldValidator from "./TextFieldValidator";

export default function validateCustomFields(fields: IField[], closeTicket: boolean) {
    let validators = {};
    fields?.filter(field => field.Is_Required && (field.Required_To === 0 || (field.Required_To === 1 && closeTicket))).map(field => {
        var validMsg = null;
        switch (field.Field_Type_Id) {
            case 1:
                validMsg = textFieldValidator(field);
                break
            case 2:
                validMsg = dropdownFieldValidator(field);
                break
            case 3:
                //DateField
                validMsg = dateFieldValidator(field);
                break
            case 4:
                // TimeField
                validMsg = numberFieldValidator(field);
                break
            case 5:
                // NumericField
                validMsg = numberFieldValidator(field);
                break
            case 8: //End user
                validMsg = endUserFieldValidator(field);
                break
            case 6:
                validMsg = dropdownFieldValidator(field);
                break
            case 7:
                //ClientField
                validMsg = dropdownFieldValidator(field);
                break
            case 9:
                return null//NumericField
            default:
                return null
        }
        if (validMsg)
            validators = { ...validators, ...{ ['field_' + field.ID]: validMsg } };
    })
    //console.log('validateCustomFields',validators)
    return validators;
}